import { render, staticRenderFns } from "./bulk-upload.vue?vue&type=template&id=40b38bd3&"
import script from "./bulk-upload.vue?vue&type=script&lang=js&"
export * from "./bulk-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports